export default __webpack_public_path__ + "static/media/2022_Grainger_et_al_2022_AmericanNaturalist.c7d1d9d4.pdf";